import { Component } from '@angular/core';

@Component({
  selector: 'app-footer-grid',
  imports: [],
  templateUrl: './footer-grid.component.html',
  styleUrl: './footer-grid.component.scss'
})
export class FooterGridComponent {

    currentYear = new Date().getFullYear();
    
}
